import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofBar() {
  const stats = [{
    number: '+300',
    label: 'entrenadores',
    isNumber: true
  }, {
    number: '6+6',
    label: 'Tomos + Bonus',
    isNumber: true
  }, {
    number: '4.9/5',
    label: <>
          calificación <span data-id="element-283">⭐</span>
        </>,
    isNumber: true
  }, {
    number: '🇦🇷',
    label: 'Argentina',
    isNumber: false
  }];
  const testimonials = [{
    initials: 'MP',
    text: 'Organicé todo el año en una tarde. Nunca más llego sin saber qué hacer.',
    name: 'Martín P.',
    location: 'Buenos Aires 🇦🇷'
  }, {
    initials: 'LG',
    text: 'Mis chicas Sub 15 mejoraron de nivel por primera vez en dos temporadas.',
    name: 'Laura G.',
    location: 'Córdoba 🇦🇷'
  }, {
    initials: 'FR',
    text: 'Antes tardaba 1 hora armando una sesión. Ahora son 5 minutos.',
    name: 'Federico R.',
    location: 'Rosario 🇦🇷'
  }];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-284">
      <div className="max-w-6xl mx-auto" data-id="element-285">
        {/* Stats bar — single pill card with 4 columns */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-bg-card border border-orange/30 rounded-card p-6 md:p-8 mb-16" data-id="element-286">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4" data-id="element-287">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="text-center" data-id="element-288">
                <div className={`text-3xl md:text-5xl font-black mb-1 leading-none ${stat.isNumber ? 'text-orange' : ''}`} data-id="element-289">
                  {stat.number}
                </div>
                <div className="text-sm md:text-base text-text-secondary font-medium" data-id="element-290">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-291">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-bg-card border-l-4 border-orange rounded-card p-6" data-id="element-292">
              <div className="flex items-center gap-3 mb-4" data-id="element-293">
                <div className="w-12 h-12 rounded-full bg-orange flex items-center justify-center font-bold text-white" data-id="element-294">
                  {testimonial.initials}
                </div>
                <div data-id="element-295">
                  <p className="font-bold" data-id="element-296">{testimonial.name}</p>
                  <p className="text-sm text-text-secondary" data-id="element-297">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <p className="text-text-secondary italic" data-id="element-298">"{testimonial.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}